import './VisitUs.css'
import { FaLocationDot } from "react-icons/fa6";

const VisitUs = () => {
    return (
        <div>
            <div className="visitus" data-aos="fade-up"
                data-aos-duration="1000">
                <div className='visitus-heading'>
                    <h3>visit us</h3>
                    <hr />
                </div>
                <div className='visitus-address flex flex-col space-y-5 text-[18px] max-sm:text-sm'>
                    <p className='flex items-center gap-2'><FaLocationDot size={22} color="#EB4236" />25/26-H, Broadway Commercial, Khayaban-e-Amin, Lahore</p>
                    <p className='flex items-center gap-2'><FaLocationDot size={22} color="#EB4236" /> 43 C Springs Meadows, Bahria Town Lahore</p>
                    <p className='flex items-center gap-2'><FaLocationDot size={22} color="#EB4236" /> 37–46/CC, Sector-B, Pine Avenue, Khayaban-e-Amin, Lahore</p>
                </div>
            </div>
            <div className="visitus-img" data-aos="fade-up"
                data-aos-duration="1000">
                <img src="./HomePhotos/VisitUs/2.jpg" alt="" />
            </div>
        </div>
    )
}

export default VisitUs